import { Validator } from '@/components/UberForm/Validators'
import { AppDispatch, checkUniqueName } from '@/store/utils'

import { asyncDebounce } from './async'

export const uniqueNameValidator = (
	dispatch: AppDispatch,
	original?: string,
	systemFolderId?: number,
	debounceMs = 1000,
): Validator => {
	return asyncDebounce(async (value) => {
		if (!value || typeof value !== 'string' || value === original) {
			return
		}

		const res = await dispatch(checkUniqueName(value, systemFolderId))

		if (res.errors && (res.errors?.length ?? 0) > 0) {
			return res.errors.join('\n')
		}

		return
	}, debounceMs)
}
